import { serverAddr } from "../networkConfig";
// fileServerAddr , fileServerAddr, serverAddrForCSV
export default {
	getLocationsAll() {
		return serverAddr.get(`/outlet/locations/?get_all=true`);
	},
	addLocation(params) {
		return serverAddr.post(`outlet/locations/`, params);
	},
	uploadExcelJSON(params) {
		return serverAddr.post(`outlet/locations/bulk/upload/`, params);
	},
	uploadExcelStoreTimings(params) {
		return serverAddr.post(`settings/business/days/bulk/upload/`, params);
	},
	editLocation(params, id) {
		return serverAddr.patch(`outlet/locations/${id}/`, params);
	},
	deleteLocation(id) {
		return serverAddr.delete(`outlet/locations/${id}`);
	},
	getCityId() {
		return serverAddr.get(`outlet/city/?fields=name,id&get_all=true`);
	},
	createCity(params) {
		return serverAddr.post(`outlet/city/`, params);
	},
	listAllStoreTimings(id) {
		return serverAddr.get(
			`settings/business/days/get_all_store_times/?store=${id}`
		);
	},
	create24HourData(params) {
		return serverAddr.post(`settings/store/details/`, params);
	},
	update24HourData(id, params) {
		return serverAddr.patch(`settings/store/details/${id}/`, params);
	},
	get24HourData(id) {
		return serverAddr.get(
			`settings/store/details/?store=${id}&get_all=true`
		);
	},
	createUpdateStoreTimings(params) {
		return serverAddr.post(
			`settings/business/days/create-update-all-times/`,
			params
		);
	},
	listOutletLevels() {
		return serverAddr.get(`outlet/level/?get_all=true`);
	},
	getOutletLevel(params) {
		return serverAddr.post(`outlet/locations/level-based/`, params);
	},
	getAllOutlets() {
		return serverAddr.get(
			`outlet/locations/?get_all=true&fields=id,name&level=3`
		);
	},
	createLevelHeaders(params) {
		return serverAddr.post(`outlet/level/`, params);
	},
	ListAllUsers() {
		return serverAddr.get(`users/?get_all=true`);
	},
	updateOrCreateStorePlan(storeDetailsId, payload) {
		return serverAddr.patch(
			`/settings/store/details/${storeDetailsId}/`,
			payload
		);
	},
	getStoreSectionFunctions(param) {
		return serverAddr.post(`/sections/get-store-sections/`, param);
	},
	addOrUpdateSectionFunction(param) {
		return serverAddr.post(`/sections/save-store-sections/`, param);
	},
	changeLocationStatus(param) {
		return serverAddr.post(`/outlet/locations/enable-disable-location/`, param);
	},
	getAllLevelsData() {
		return serverAddr.get(`outlet/location/`);
	},
	addLevel(payload) {
		return serverAddr.post(`outlet/level/`, payload);
	},
	deleteLevel(payload) {
		return serverAddr.post(`outlet/level/delete_location_level/`, payload);
	},
	assignLocations(payload) {
		return serverAddr.post(`outlet/locations/update-location-relationship/`, payload);
	}
};
